import { HttpClient } from '@angular/common/http';

import { Component, OnInit } from '@angular/core';

import {

  FormBuilder,

  FormControl,

  FormGroup,

  Validators,

} from '@angular/forms';

import { DomSanitizer } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

import { NationalCodeService, PersianNumberService } from 'ngx-persian';

declare var bootstrap: any;

declare let $: any;
@Component({

  selector: 'app-profile',

  templateUrl: './profile.component.html',

  styleUrls: ['./profile.component.css'],
})

export class ProfileComponent implements OnInit {

  list_City: any[] = [];

  bForAnother: Boolean = false;

  bHasStop: Boolean = false;

  bCargo: Boolean = false;

  bForeigner: Boolean = false;

  bInvoiceRequired: Boolean = false;

  showCustom_Map: boolean = false;

  iState: number = 1;

  map: any;

  source: any;

  vector: any;

  layers: any = [];

  mapHeader: any;

  mapMode: any;

  vectorLayer: any;

  origin: any;

  destination: any;

  Info: any;

  currentTime: any;

  currentClock: any;

  prices: any;

  invoice: any;

  atLeastTime: number;

  selectedFile: any;

  constructor(
    
    private accountService: AccountService,

    private router: Router,

    private otherService: OtherService,

    private toastr: ToastrService,

    private formBuilder: FormBuilder,

    private http: HttpClient,

    private route: ActivatedRoute,

    private sanitizer: DomSanitizer,

    private persianNumber: PersianNumberService,

    private _NationalCode: NationalCodeService,

  ) { }

  path: FormGroup = this.formBuilder.group({
    origin: new FormControl('', Validators.required),
    destination: new FormControl(''),
    olatIn: new FormControl(0, Validators.required),
    dlatIn: new FormControl('', Validators.required),
    olongIn: new FormControl(0, Validators.required),
    dlongIn: new FormControl('', Validators.required),
    addressBar: new FormControl(''),
    duration: new FormControl(''),
    distance: new FormControl(''),
  });

  mdl_Map: FormGroup = this.formBuilder.group({
    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),
  });

  mdl_TripSAD: FormGroup = this.formBuilder.group({
    strCity: new FormControl(''),
    strName: new FormControl(''),
    strFamily: new FormControl(''),
    strMobile: new FormControl(''),
    strID: new FormControl(''),
    strAddress: new FormControl(''),
    strBankAccount: new FormControl(''),
    tiSex: new FormControl(2),
    fLon: new FormControl(0, Validators.required),
    fLat: new FormControl(0, Validators.required),
  });

  ngOnInit(): void {

    this.Info = this.otherService.getLocalStorage();

    this.getListCity();

    this.setBaseData();
  }

  getListCity = async () => {
    this.accountService.TaxiLon_City_List().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.list_City = res;
    });
  };

  setBaseData() {

    this.selectedFile = this.Info.strAvatar;

    this.mdl_TripSAD.controls['strName'].setValue(this.Info.strName.trim());

    this.mdl_TripSAD.controls['strFamily'].setValue(this.Info.strFamily.trim());

    this.mdl_TripSAD.controls['strID'].setValue(this.Info.strID.trim());

    this.mdl_TripSAD.controls['strMobile'].setValue(this.Info.strMobile.trim());

    this.mdl_TripSAD.controls['tiSex'].setValue(this.Info.tiSex);

    this.mdl_TripSAD.controls['strCity'].setValue(this.Info.strCity.trim());

    this.mdl_TripSAD.controls['strAddress'].setValue(
      this.Info.strAddress.trim()
    );

    this.mdl_TripSAD.controls['strBankAccount'].setValue(
      this.Info.strBankAccount.trim()
    );

  }

  editProfile() {

    let model = this.mdl_TripSAD.value;

    model.iTaxiLon_User = this.Info.Id;

    model.strSession = this.Info.session;

    model.strAvatar = this.selectedFile;

    if (model.strName == '') return this.accountService.toastSwal('error', 'نام را وارد کنید');

    if (model.strFamily == '') return this.accountService.toastSwal('error', 'نام خانوادگی را وارد کنید');

    if (model.strID == '') return this.accountService.toastSwal('error', ' کد ملی را وارد کنید');

    if (!this._NationalCode.isValid(model.strID)) return this.accountService.toastSwal('error', 'کد ملی وارد شده صحیح نمی باشد');

    this.accountService.TaxiLon_User_Update(model).subscribe((data: any) => {

      let resp = JSON.parse(data.toString());

      let res = resp[0];

      if (res.iResult == 0 || res.bError) return this.accountService.toastSwal('error', res.strError);

      this.accountService.toastSwal('success', 'پروفایل با موفقیت ویرایش شد');

      var mdl = {
        strCityName: res.strCityName,
        session: res.strSession,
        Id: res.iTaxiLon_User,
        strName: res.strName,
        strFamily: res.strFamily,
        strID: res.strID,
        strMobile: res.strMobile,
        tiSex: res.tiSex,
        strCity: res.strCity,
        strAddress: res.strAddress,
        strBankAccount: res.strBankAccount,
        strAvatar: res.strAvatar,
        strFullName: res.strFullName,
        fLat: res.fLat,
        fLon: res.fLon,

        CityCode: res.strCityCode,
      };

      localStorage.setItem('db30a17f18d1a8a3l0ifr4z8ab0b02', this.accountService.encrypt(JSON.stringify(mdl)));

      this.router.navigateByUrl('/');

    });

  }

  onFileSelected(event) {

    const file = event.target.files[0];

    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {

      this.selectedFile = reader.result as string;

      this.resizeBase64Image(this.selectedFile, 500, 650).then((resizedBase64) => {

        this.selectedFile = resizedBase64;

        this.selectedFile = this.selectedFile.split(',')[1];

        this.Info.strAvatar = this.selectedFile;

      }).catch((error) => { });

    };

  }

  resizeBase64Image(base64, width, height) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const resizedBase64 = canvas.toDataURL();
        resolve(resizedBase64);
      };
      img.onerror = (error) => {
        reject(error);
      };
    });
  }

  setValue_Filter(event: any, strKey: string) {
    if (event?.strCityName) {
      if (strKey == 'strCity') {
        this.mdl_TripSAD.patchValue({
          strCity: event.strCity,

          fLon: event.fLon,

          fLat: event.fLat,
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strDCity: event.strCity,

          fDLon: event.fLon,

          fDLat: event.fLat,
        });
      }
    } else {
      if (strKey == 'strCity') {
        this.mdl_TripSAD.patchValue({
          strCity: '',

          fLon: '',

          fLat: '',
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strDCity: '',

          fDLon: '',

          fDLat: '',
        });
      }
    }
  }

  show_Map(mdl_Type: 'strAddress' | 'strDAddress') {
    if (mdl_Type == 'strAddress') {
      this.mdl_Map.patchValue({
        strAddress: this.mdl_TripSAD.get('strAddress')?.value,

        fLon: this.mdl_TripSAD.get('fLon')?.value,

        fLat: this.mdl_TripSAD.get('fLat')?.value,

        strSource: 'strAddress',
      });

      this.showCustom_Map = true;
    } else {
      this.mdl_Map.patchValue({
        strAddress: this.mdl_TripSAD.get('strDAddress')?.value,

        fLon: this.mdl_TripSAD.get('fDLon')?.value,

        fLat: this.mdl_TripSAD.get('fDLat')?.value,

        strSource: 'strDAddress',
      });

      this.showCustom_Map = true;
    }
  }

  submitMap(event: any) {
    this.showCustom_Map = false;

    if (this.mdl_Map.get('strSource')?.value == 'strAddress') {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strAddress: event.strText,

          fLon: event.longitude,

          fLat: event.latitude,
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strAddress: '',

          fLon: '',

          fLat: '',
        });
      }
    } else {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strDAddress: '',

          fDLon: '',

          fDLat: '',
        });
      }
    }
  }

  returnStrValue(
    strKey: string,
    strKeyValue: number | string,
    lst_: [] | any,
    strComment: string
  ): string {
    return this.otherService.initialFilterValue(
      strKey,
      strKeyValue,
      lst_,
      strComment
    );
  }

    filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }

}
